  <template>
  <b-modal size="xl" v-model="show" centered :title="'Aufgabenverteilung: ' + subject"
  >
    <b-row>
      <b-col class="pt-1 pb-1" style=" border-right: 1px solid #a9a9a9">
        <b-row>
          <b-col><span><b>Mitarbeiter oder Gruppe wählen</b></span></b-col>
          <b-col>
          <b-tabs align="right" content-class="mt-3" style="padding-left: 26px;" v-model="currentTab">
          <b-tab title="Liste"></b-tab>
          <b-tab title="Baumstruktur"></b-tab>
        </b-tabs>
          </b-col>
        </b-row>
        <b-form-input v-if="mode === 'list'" v-model="searchVal" placeholder="Suche" type="search" debounce="150"></b-form-input>
        <v-jstree v-if="mode === 'tree'" ref="js_tree" :allow-transition="false"
                  style="margin-top: 0rem; flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem; height: 30vh; overflow: auto;"
                  class="my-tree" :data="structure"
                  @item-click="onNodeSelected"
                  show-checkbox></v-jstree>
        <v-jstree v-if="mode === 'list'" ref="js_list" :allow-transition="false"
                  style="margin-top: 0rem; flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem; height: 30vh; overflow: auto;"
                  class="my-tree" :data="listVal"
                  @item-click="onNodeSelected"
                  show-checkbox></v-jstree>
      </b-col>
      <b-col class="pt-1 pb-1">
        <span><b>Ausführungsdatum wählen</b></span>
        <b-row class="m-0" style="margin-top: 0.5rem !important;">
            <b-form-radio-group
                v-model="selectedDate"
                :options="dateOptions"
                button-variant="outline-primary"
                buttons
            ></b-form-radio-group>
          <datetime
              style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; margin-left: auto"
              v-model="currentDate"
              input-class="form-control"
              input-style="color: black;"
              input-id="date"
              :phrases="datetimeConfig.phrases"
              :format="{ dateStyle: 'full'}"
              :min-datetime="datetimeConfig.minTime"
          @input="onDateChanged"></datetime>
        </b-row>
        <b-table striped bordered hover responsive :items="currentTodos" style="margin-top: 8px; max-height: 30vh; overflow: auto;"
                 :fields="todoFields">
          <template v-slot:cell(task_name)="row">
            <div v-if="row.item.task_name === 'Urlaub'">
              <b>{{row.item.task_name}}</b>
            </div>
            <div v-else>
              <b>{{row.item.task_name}}</b>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row class="mt-3 pb-3 mb-2" style="border-bottom: 1px solid #a9a9a9">
      <b-col></b-col>
      <b-col style="    display: flex;
    flex-direction: row;">
        <b-button variant="success" class="text-center justify-content-center flex-grow-1" :disabled="!canContinue" @click="onAddPlanning">
          <chevron class="icon-1_5x ic-chevron" fillColor="#ac121b" :size="72" style="color:white; position: inherit;" ></chevron>
          <b>Zuweisen</b>
          <chevron class="icon-1_5x ic-chevron" fillColor="#ac121b" :size="72" style="color:white; position: inherit;" ></chevron>
        </b-button>
        <b-button variant="success" class="text-center justify-content-center" style="margin-left: 15px" :disabled="!canContinue" v-if="selected && selected.node_type === 'user' && false">
          <chat class="icon-1_5x ic-chevron" fillColor="#ac121b" :size="72" style="color:white; position: inherit;" ></chat>
          <b>Kontaktieren</b>
        </b-button>
      </b-col>
      <b-col></b-col>
    </b-row>
    <b-row style="flex-direction: row-reverse; margin-right: 8px">
      <pencil-plus-icon title="" v-tooltip="'Anpassen'" class="icon-1_5x" fillColor="#2463ea" style=" cursor: pointer; color: #016d03; margin-left: 4px;margin-bottom: 2px;" :size="72"
                        @click="$emit('change-todo', {name: currentPlanning.name, memo: currentPlanning.message, dueDate: currentPlanning.till})"></pencil-plus-icon>
      <minus-icon title="" v-tooltip="'Entfernen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="onDeletePlanning"></minus-icon>
    </b-row>
    <b-row>
      <b-col>
        <b-table striped bordered hover responsive :items="taskTodos" style="max-height: 30vh; overflow: auto;"
                 :fields="taskTodoFields"
                 selectable
                 select-mode="single"
                 selectedVariant="primary"
                 @row-selected="onRowSelected">
          <template v-slot:cell(is_finished)="row">
            <!--i class="icon-clock icons font-xl d-block" v-if="row.item.offen === 0"></i-->
            <book-open-page-variant-icon class="icon-1_5x" fillColor="#ac121b" :size="72" style="color:red" v-if="!row.item.is_finished"></book-open-page-variant-icon>
            <check-bold-icon class="icon-1_5x" fillColor="#16aa13" :size="72" style="color: green" v-else></check-bold-icon>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="show = false">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" @click="$emit('todos-updated', getReturnData()); show = false">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import VJstree from 'vue-jstree'
import ChLeft from 'vue-material-design-icons/ChevronLeft';
import ChRight from 'vue-material-design-icons/ChevronRight';
import {parseTimestamp} from "@/shared/dates";
import {DateTime as LuxonDateTime} from "luxon";
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import BookOpenPageVariantIcon from 'vue-material-design-icons/BookOpenPageVariant.vue';
import CheckBoldIcon from 'vue-material-design-icons/CheckBold.vue';
import PencilPlusIcon from 'vue-material-design-icons/PencilPlus.vue';
import PlusIcon from 'vue-material-design-icons/PlusCircle.vue';
import MinusIcon from 'vue-material-design-icons/MinusCircle.vue';
import Chevron from 'vue-material-design-icons/ChevronDown.vue';
import Chat from 'vue-material-design-icons/Chat.vue';
import {v4} from "uuid";


export default {
  name: "UpdateTodosDialog",
  components: {VJstree, ChLeft, ChRight,BookOpenPageVariantIcon,
    CheckBoldIcon,PencilPlusIcon,
    PlusIcon,
    MinusIcon,Chevron, Chat},
  data() {
    return {
      subject: "",
      show: false,
      loader: undefined,
      structure: [],
      mitaFlat: [],
      mode: 'list',
      searchVal: '',
      cleanStructure: [],
      currentTab: 0,
      todos: [],
      memo: "",
      selected: null,
      currentDate: null,
      selectedDate: -1,
      taskId: "",
      dateOptions: [
        { text: 'Mo', value: 1 },
        { text: 'Di', value: 2 },
        { text: 'Mi', value: 3 },
        { text: 'Do', value: 4 },
        { text: 'Fr', value: 5 },
        { text: 'Sa', value: 6 },
        { text: 'So', value: 7 },
      ],
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      inputActive: false,
      ignoreUpdate: false,
      todoFields: [
        {key: 'task_name', label: 'Aufgabe'},
        {key: 'till', label:"Termin", formatter: (value, key, item) => {
            if (value === null) {
              return ""
            }
            let event = new Date(value.replace('Z',''));
            let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            return event.toLocaleDateString('de-DE', options);
          }},
      ],
      deletedIds: [],
      newIds: [],
      changedIds: [],
      currentPlanning: null,
      taskTodos: [],
      taskTodoFields: [
        {key: 'is_finished', label: 'Status'},
        {key: 'user_id', label:"Zuweisung", formatter: (value, key, item) => {
            if (item === null) {
              return null;
            }
            if (item.name !== "") {
              return item.name;
            }
            let res = JSON.parse(sessionStorage.getItem(item.user_id));
            if (res === null) {
              return value;
            }
            return res.first_name + " " + res.surname;
          }},
        {key: 'till', label:"Termin", formatter: (value, key, item) => {
            if (value === null) {
              return ""
            }
            let event = new Date(value.replace('Z',''));
            let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            return event.toLocaleDateString('de-DE', options);
          }},
        {key: 'message', label: "Aufgabenbeschreibung", formatter: (value, key, item) => {
            if (item === null) {
              return null;
            }
            let res = item.message;
            let n = 50;
            return (res.length > n) ? res.slice(0, n-1) + '...' : res;
          }},
      ],
    }
  },
  watch: {
    selectedDate(n, o) {
      if (!this.currentDate || o === -1 || this.ignoreUpdate) {
        this.ignoreUpdate = false;
        return;
      }
      let toAdd = n - o;
      let date = new Date(Date.parse(this.currentDate));
      date.setDate(date.getDate() + toAdd);
      this.currentDate = date.toISOString();
    },
    currentTab(n, o) {
      this.clearSelection();
      this.searchVal = '';
      if (n === 1) {
        this.mode = 'tree';
      } else {
        this.mode = 'list';
      }
    },
  },
  computed: {
    canContinue() {
      return this.selected !== null;
    },
    formateDate() {
      return parseTimestamp(this.currentDate, "full")
    },
    listVal() {
      if (this.searchVal === '') {
        return this.mitaFlat;
      } else {
        return this.mitaFlat.filter((data) => data.text.toLowerCase().includes(this.searchVal.toLowerCase()))
      }
    },
    currentTodos() {
      if (!this.selected) {
        return []
      }
      let d = parseTimestamp(new Date(Date.parse(this.currentDate)), "DD.MM.YYYY")
      if (!this.todos[this.selected.id] || !this.todos[this.selected.id][d]) {
        return []
      }
      for (let i = 0; i < this.deletedIds.length; i++) {
        for (let j = 0; j < this.todos[this.selected.id][d].length; j++) {
          if (this.todos[this.selected.id][d][j].id === this.deletedIds[i]) {
            this.todos[this.selected.id][d].splice(j, 1);
            break;
          }
        }
      }
      return this.todos[this.selected.id][d];
    }
  },
  methods: {
    computeMitaFlat(data) {
      let res = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type !== "user") {
          /*let cur = {...data[i]}
          cur.children = []
          res.push(cur)*/
          res = res.concat(this.computeMitaFlat(data[i].children))
        } else {
          let cur = {...data[i]}
          res.push(cur)
        }
      }
      res.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
      return res;
    },
    getReturnData() {
      let res = {
        todos: this.taskTodos,
        deleted_ids: this.deletedIds,
        changed_ids: this.changedIds,
        new_ids: this.newIds,
      }
      return res;
    },
    onRowSelected(data) {
      if (data.length) {
        this.currentPlanning = data[0];
      } else {
        this.currentPlanning = null;
      }
    },
    showLoader() {
      this.hideLoader();
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    onDateChanged(d) {
      if (!this.inputActive) {
        return;
      }
      this.ignoreUpdate = true;
      this.selectedDate = new Date(Date.parse(d)).getDay() % 7;
      this.queryTodos();
    },
    onNodeSelected(node, item, e) {
      this.selected = item;
    },
    queryTodos() {
      let left = 1 - this.selectedDate
      let right = 7 - this.selectedDate
      let start = new Date(Date.parse(this.currentDate));
      start.setDate(start.getDate() + left)
      let end = new Date(Date.parse(this.currentDate));
      end.setDate(end.getDate() + right)
      start = encodeURIComponent(parseTimestamp(start, "DD.MM.YYYY"))
      end = encodeURIComponent(parseTimestamp(end, "DD.MM.YYYY"))
      this.showLoader();
      this.$http.get(
          Server_URL + '/auftragsbuch/data/av/todos/' + this.taskId  + "?from=" + start + "&till=" + end
      ).then(this.handleDataOk, this.responseError)
    },

    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_Login;
      }
    },
    handleDataOk(response) {
      if (response.status === 200) {
        this.todos = this.addTaskTodos(response.body);
        this.hideLoader();
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    addTaskTodos(todos) {
      for (let i = 0; i < this.taskTodos.length; i++) {
        this.taskTodos[i].task_name = this.subject;
        let current = this.taskTodos[i];
        let d = parseTimestamp(new Date(Date.parse(current.till)), "DD.MM.YYYY")
        if (todos[current.user_id] && todos[current.user_id][d]) {
          todos[current.user_id][d].push(current);
        } else if (todos[current.user_id]) {
          todos[current.user_id][d] =  {};
          todos[current.user_id][d] = [current];
        } else {
          todos[current.user_id] = {};
          todos[current.user_id][d] = {};
          todos[current.user_id][d] = [current]
        }
      }
      return todos;
    },
    showDialog(structure, todos, memo, taskId, subject) {
      this.subject = subject;
      this.taskId = taskId;
      this.cleanStructure = JSON.parse(JSON.stringify(structure));
      this.structure = JSON.parse(JSON.stringify(structure));
      this.computeMitas(this.structure)
      this.computeMitas(this.cleanStructure)
      this.mitaFlat = this.computeMitaFlat(this.structure);
      this.taskTodos = JSON.parse(JSON.stringify(todos))
      this.memo = memo;
      this.selected = null;
      this.inputActive = false;
      this.deletedIds = [];
      this.newIds = [];
      this.changedIds = [];
      this.selectedDate = new Date().getDay() % 7;
      this.currentDate = LuxonDateTime.local().toISO();
      this.$nextTick(() => {
        this.inputActive = true;
      });
      this.queryTodos();
      this.show = true;

    },
    clearSelection() {
      this.structure = JSON.parse(JSON.stringify(this.cleanStructure));
      this.selected = null;
      this.mitaFlat = this.computeMitaFlat(this.structure);
    },
    computeMitas(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type === "user") {
          let cur = {...data[i]}
          let parsed = JSON.parse(sessionStorage.getItem(cur.id));
          if (parsed) {
            cur.text = parsed.full_name;
          }
          data[i] = cur;
        } else {
          this.computeMitas(data[i].children)
        }
      }
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
    },
    onDeletePlanning() {
      if (!this.currentPlanning) {
        return;
      }
      for (let i = 0; i < this.taskTodos.length; i++) {
        if (this.taskTodos[i].id === this.currentPlanning.id) {
          this.taskTodos.splice(i, 1);
          this.deletedIds.push(this.currentPlanning.id);
          break;
        }
      }
      for (let i = 0; i < this.newIds.length; i++) {
        if (this.newIds[i] === this.currentPlanning.id) {
          this.newIds.splice(i, 1);
          break;
        }
      }
      for (let i = 0; i < this.changedIds.length; i++) {
        if (this.changedIds[i] === this.currentPlanning.id) {
          this.changedIds.splice(i, 1);
          break;
        }
      }
      this.currentPlanning = null;
    },
    onAddPlanning() {
      let newTodo = {
        id: v4(),
        is_finished: false,
        message: this.memo,
        name: this.selected.text,
        task_id: this.taskId,
        till: this.currentDate,
        user_id: this.selected.id,
        todo_type: "ab",
        task_name: this.subject,
      }
      this.taskTodos.push(newTodo);
      this.newIds.push(newTodo.id);
      let d = parseTimestamp(new Date(Date.parse(this.currentDate)), "DD.MM.YYYY")
      if (this.todos[this.selected.id] && this.todos[this.selected.id][d]) {
        this.todos[this.selected.id][d].push(newTodo);
      } else if (this.todos[this.selected.id]) {
        this.$set(this.todos[this.selected.id], d, {})
        this.todos[this.selected.id][d] = [newTodo];
      } else {
        this.$set(this.todos, this.selected.id, {})
        this.$set(this.todos[this.selected.id], d, {})
        this.todos[this.selected.id][d] = [newTodo]
      }
    },
    onChangeTodo(todo) {
      // first check if planning has changed at all
      if (this.currentPlanning.message === todo.memo && Date.parse(this.currentPlanning.till) === Date.parse(todo.dueDate)) {
        return
      }
      let isNew = false;
      for (let i = 0; i < this.newIds.length; i++) {
        if (this.newIds[i] === this.currentPlanning.id) {
          isNew = true;
          break
        }
        for (let i = 0; i < this.changedIds.length; i++) {
          if (this.changedIds[i] === this.currentPlanning.id) {
            isNew = true;
            break;
          }
        }
      }
      if (!isNew) {
        this.changedIds.push(this.currentPlanning.id);
      }
      // remove old todo
      let d = parseTimestamp(new Date(Date.parse(this.currentPlanning.till)), "DD.MM.YYYY")
      if (this.todos[this.currentPlanning.user_id] && this.todos[this.currentPlanning.user_id][d]) {
        for (let i = 0; i < this.todos[this.currentPlanning.user_id][d].length; i++) {
          if (this.todos[this.currentPlanning.user_id][d][i].id === this.currentPlanning.id) {
            this.todos[this.currentPlanning.user_id][d].splice(i, 1);
            break
          }
        }
      }
      this.currentPlanning.message = todo.memo;
      this.currentPlanning.till = todo.dueDate;
      d = parseTimestamp(new Date(Date.parse(this.currentPlanning.till)), "DD.MM.YYYY")
      if (this.todos[this.currentPlanning.user_id] && this.todos[this.currentPlanning.user_id][d]) {
        this.todos[this.currentPlanning.user_id][d].push(this.currentPlanning);
      } else if (this.todos[this.currentPlanning.user_id]) {
        this.$set(this.todos[this.currentPlanning.user_id], d, {})
        this.todos[this.currentPlanning.user_id][d] = [this.currentPlanning];
      } else {
        this.$set(this.todos, this.currentPlanning.user_id, {})
        this.$set(this.todos[this.currentPlanning.user_id], d, {})
        this.todos[this.currentPlanning.user_id][d] = [this.currentPlanning]
      }
    }
  },
}
</script>

<style scoped>

::v-deep .tab-content {
  display: none !important;
}
::v-deep .material-design-icon > .material-design-icon__svg {
  bottom: inherit;
}

.ic-chevron {
  color:#6e6e6e;
  vertical-align: middle;
  cursor: pointer;
  margin: 0px;
}
.ic-chevron.inactive {
  color: #919191;
  cursor: default;
}

.ic-chevron > .material-design-icon__svg {
  position: inherit !important;
}

</style>

<style>
.no-select{
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.ic-chevron > .material-design-icon__svg {
  position: inherit !important;
}
</style>
